import get from 'lodash-es/get';

export default namespaceSettings =>
  get(namespaceSettings, 'namespaceInfo.name', '');



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/get-namespace.js